import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch"

const deleteProjectAssignment = (
    backend: string,
    token: string,
    id: number
) => {
    return fetch(
        `${getApiUrl(backend)}assignments/${id}`,
        {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
        }
    );
};

export default deleteProjectAssignment;
